import companyApi from '../../api/companyApi'
import { CompanyListRequest, CompanyListResponse, Documents } from './types'

const companyApiSlice = companyApi.injectEndpoints({
  endpoints: (build) => ({
    getCompany: build.query<CompanyListResponse, CompanyListRequest>({
      query: ({ page, id, filters }) => {
        const params: { [key: string]: any } = {
          size: page?.size,
          page: page?.number ? page.number - 1 : 0
        }
        if (id) {
          params.id = id
        }
        if (filters && filters.length > 0) {
          filters.forEach(({ fieldName, fieldValue }) => {
            if (
              fieldValue === null ||
              fieldValue === undefined ||
              fieldValue === '' ||
              fieldValue === 'all'
            ) {
              delete params[fieldName]
            } else {
              params[fieldName] = fieldValue
            }
          })
        }
        return {
          url: '/company/extended',
          method: 'GET',
          params
        }
      },
      providesTags: ['company']
    }),
    getCompnayDocs: build.query<
      CompanyListResponse,
      { id?: string | undefined }
    >({
      query: ({ id }) => {
        return {
          url: `/companies/${id}`,
          method: 'GET'
        }
      },
      providesTags: ['company']
    }),
    updateDocument: build.mutation<
      CompanyListResponse,
      { documents: Documents, id: number }
    >({
      query: ({ id, documents }) => ({
        url: `/company/verify-document/${id}`,
        method: 'PATCH',
        data: documents
      }),
      invalidatesTags: ['company']
    })
  })
})

export const {
  useGetCompanyQuery,
  useUpdateDocumentMutation,
  useGetCompnayDocsQuery
} = companyApiSlice
